<template>
    <div class="box" v-if="requests">
      <table class="table" cellspacing="0" cellpadding="0">
        <thead>
          <tr>
            <th>Booking Ref</th>
            <th>Status</th>
            <th>Tour</th>
            <th>Departure Date</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="booking of requests" :key="booking.id">
            <td><router-link :to="{name: 'booking-edit', params: {id:booking.id}}">{{booking.booking_ref}}</router-link></td>
            <td><strong v-if="booking.status == 'Cancelled'">{{ booking.status }}</strong><span v-else>{{ booking.status }}</span></td>
            <td>{{booking.tour_bookings[0].tour.name}}</td>
            <td>{{booking.departure_date}}</td>
          </tr>
        </tbody>
      </table>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  name: 'CustomerBookings',
  props : {
    customer: Object
  },
  data () {
    return {
      bookings: null,
      requests: null,
      selectedBookings: 0,
      quantity: 1,
      referrer_id: null,
      referrers: []
    }
  },
  computed: {
    ...mapGetters(['getLoadStatus']),
  },
  mounted () {
    // this.getBookings()
    this.getRequests()
    // this.getReferrers()
  },
  methods: {
    getBookings () {
      fetch(this.$api + 'bookings', {
          headers: {
            'Accept': 'application/json',
            'Authorization': localStorage.getItem('token')
          }
        })
      .then(res => res.json())
      .then(response => {
        this.bookings = response.data
      })
    },
    getRequests () {
      fetch(this.$api + 'customers/' + this.customer.id + '/bookings', {
          headers: {
            'Accept': 'application/json',
            'Authorization': localStorage.getItem('token')
          }
        })
      .then(res => res.json())
      .then(response => {
        this.requests = response.data
      })
    },
    getReferrers () {
      this.$store.dispatch('setLoadStatus')
      fetch(this.$api + 'referrers', {
          headers: {
            'Accept': 'application/json',
            'Authorization': localStorage.getItem('token')
          }
        })
      .then(res => res.json())
      .then(response => {
        this.referrers = response.data
        this.$store.dispatch('setLoadStatus')
      })
    },
    order() {
      this.$store.dispatch('setLoadStatus')
      for (let booking of this.selectedBookings) {

        var request = {
          customer_id: this.customer.id,
          booking_id: booking.id,
          referrer_id: this.referrer_id
        }

        fetch(this.$api + 'bookings/requests', {
          method: 'POST',
          body: JSON.stringify(request),
          headers:{
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': localStorage.getItem('token')
          }
        })
        .then(res => res.json())
        .then(response => {
          if(response.success == true) {
            this.$notify({
              type: 'success',
              title: response.message
            });
            this.getRequests();
          } else {
            this.$notify({
              type: 'error',
              title: response.message
            });
          }
        })
      }
      this.$store.dispatch('setLoadStatus')
    }
  }
}
</script>
